
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormTextInput from './FormTextInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormPassengers = ({
  type,
  colSize,
  inputLabel,
  className,
  passengers,
  handleAddPassenger,
  errors,
  handleChange,
  handleRemovePassenger,
  isDetail,
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !isDetail && (
            <CButton
              onClick={() => handleAddPassenger()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {passengers?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {passengers?.length > 0 ? (
        passengers?.map((inputField, index) => {
          return (
            <CAccordion activeItemKey={isDetail ? 0 : index+1}>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>{type == 'accomodation' ? 'Guest' : 'Passenger'} {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className="mb-4">
                    <FormTextInput 
                      id='first_name'
                      name='first_name'
                      colSize='6'
                      className='mb-3'
                      inputLabel='First Name'
                      placeholder='Enter first name...'
                      value={inputField?.first_name}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={isDetail ? null : type == 'accomodation' ? errors[`expense_${type}`]?.guets?.length > 0 && errors[`expense_${type}`]?.guets[index]?.first_name : errors[`expense_${type}`]?.passengers?.length > 0 && errors[`expense_${type}`].passengers[index]?.first_name}
                      invalid={isDetail ? null : type == 'accomodation' ? errors[`expense_${type}`]?.guets?.length > 0 && errors[`expense_${type}`]?.guets[index]?.first_name : errors[`expense_${type}`]?.passengers?.length > 0 && errors[`expense_${type}`].passengers[index]?.first_name}
                      disabled={isDetail}
                    />
                    <FormTextInput 
                      id='last_name'
                      name='last_name'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Last Name'
                      placeholder='Enter last name...'
                      value={inputField?.last_name}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={isDetail ? null : type == 'accomodation' ? errors[`expense_${type}`]?.guets?.length > 0 && errors[`expense_${type}`]?.guets[index]?.last_name : errors[`expense_${type}`]?.passengers?.length > 0 && errors[`expense_${type}`].passengers[index]?.last_name}
                      invalid={isDetail ? null : type == 'accomodation' ? errors[`expense_${type}`]?.guets?.length > 0 && errors[`expense_${type}`]?.guets[index]?.last_name : errors[`expense_${type}`]?.passengers?.length > 0 && errors[`expense_${type}`].passengers[index]?.last_name}
                      disabled={isDetail}
                    />
                  </CRow>
                  <CRow>
                    <CCol lg={1}>
                      {
                        passengers?.length > 1 && !isDetail && (
                          <CButton
                            style={styleButtonVars2}
                            onClick={() => {handleRemovePassenger(index)}}
                          >
                            Delete
                          </CButton>
                        )
                      }
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add passenger</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have passenger</b></div>
      )}
    </CCol>
  )
}

export default FormPassengers
